import { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import { logActions } from "../../../../../store/log-slice"

const Resort = (props) => {
       const { type, name } = props
       const { resort } = useFilter()
       let filteredlogs = useSelector((state) => state.log.filteredlogs)
       let logs=useSelector(state=>state.log.logs)
       let dispatch = useDispatch()
   
       return <Fragment>
           <label>{name}</label><select className="mb-2"
               onChange={(event) => {
                   let value = event.target.value
   
                   switch (value) {
                       case 'ASC':
                           dispatch(logActions.setFilteredItems(resort(filteredlogs??logs, type, 'ASC')))
                           break
   
                       case 'DESC':
                           dispatch(logActions.setFilteredItems(resort(filteredlogs??logs, type, 'DESC')))
                           break
                   }
   
               }}
   
           >
               <option value='' >Sort</option>
               <option value='ASC' >Ascending</option>
               <option value='DESC' >Descending</option>
           </select>
       </Fragment>
}

export default Resort